import { DOSSIER_RAPPORT_API,DOSSIER_HELP_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"

export const getInfo = ({ commit, state }) => {

    const url = `${DOSSIER_RAPPORT_API}`
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)
    console.log(state.params);


    backend({ url, data: null, method: "GET", params: state.params }).then(({ data }) => {

        commit(types.SET_ITEMS, data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.data?.message ?? err.message ?? err))

    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}
export const getFile = ({ commit, state }) => {

    const url = `${DOSSIER_RAPPORT_API}`
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)

    backend({ url, params: { ...state.params, export: true }, method: "GET" }).then(({ data }) => {

        // commit(types.SET_ITEMS, data?.user ?? data)

        var a = document.createElement("a")
        a.href = data?.url
        // a.href = "https://pixabay.com/get/gff5b8d086b6cfc5c1e8f5d195e9ae7be06dd710e7d6cbbf13d7d216797cf0ca2c6a1637eda761bff6cfe1376507a0d976ce4dae9619f6c46956ac8f21b90ca27528bb2a4ce48f7db28a8b99cdbd5da7a_1280.jpg?attachment="
        a.download = data?.filename ?? "file"
        a.target = "_blank"
        a.click()

        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.data?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}

export const getHelp = ({ commit, state }) => {

    const url = `${DOSSIER_HELP_API}`
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)

    backend({ url, params: { ...state.params, export: true }, method: "GET" }).then(({ data }) => {

        var a = document.createElement("a")
        a.href = data?.url
        a.download = data?.filename ?? "file"
        a.target = "_blank"
        a.click()

        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.data?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}


export const resetData = ({ commit }) => {
    commit(types.RESET)
}



